export const formatPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-digit characters except the plus sign
  let cleanedNumber = phoneNumber.replace(/[^\d+]/g, '');

  // Ensure the phone number starts with a plus sign
  if (!cleanedNumber.startsWith('+')) {
    cleanedNumber = '+' + cleanedNumber;
  }

  return cleanedNumber;
};

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  const cleanedNumber = phoneNumber.replace(/\s+/g, '');

  return /^[\d()+-.]+$/.test(cleanedNumber);
};
